/**
 * @description: 筛选请求是否显示进度加载条
 * @return {*}
 * @param {*} url
 */
export function shouldShowLoadingBar(url) {

    const specificUrls = ["/user/code", "/sysMenu/mainMenus"]; // 不显示加载条的网络请求

    return !specificUrls.includes(url);
}

/**
 * 节流
 * @param {*} fn 
 * @param {*} delay 
 * @returns 
 */
export function debounce(fn, delay) {
    let timer = null;
    return function () {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, arguments);
        }, delay);
    };
}

export function getUserToTaskExamine(id) {
    let usersId = [2, 6];
    return usersId.includes(Number(id));
}

/**
 * 数字转大写
 * @param {number} num 数字
 */
export const NUMBER_TO_CHINESE = (num) => {
    if (isNaN(num)) return '输入的不是数字';

    const bigNumbers = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    const units = ['', '拾', '佰', '仟'];
    const bigUnits = ['', '万', '亿', '兆'];
    const smallUnits = ['角', '分'];

    const [integerPart, decimalPart] = num.toFixed(2).split('.');
    let chineseStr = '';

    // 处理整数部分，按4位分组
    const sections = [];
    let temp = integerPart;
    while (temp.length > 0) {
        sections.unshift(temp.slice(-4));
        temp = temp.slice(0, -4);
    }

    // 处理每个分组
    for (let i = 0; i < sections.length; i++) {
        let section = sections[i];
        let sectionResult = '';
        let zeroFlag = false;
        for (let j = 0; j < section.length; j++) {
            const digit = section.charAt(j);
            const pos = section.length - j - 1;
            if (digit === '0') {
                zeroFlag = true;
            } else {
                if (zeroFlag) {
                    sectionResult += '零';
                    zeroFlag = false;
                }
                sectionResult += bigNumbers[parseInt(digit)] + units[pos];
            }
        }
        sectionResult = sectionResult.replace(/零+$/, '');
        if (sectionResult) {
            chineseStr += sectionResult + bigUnits[sections.length - i - 1];
        } else {
            // 如果不是最后一组且前面有内容，补零
            if (i !== sections.length - 1 && chineseStr && chineseStr[chineseStr.length - 1] !== '零') {
                chineseStr += '零';
            }
        }
    }

    chineseStr = chineseStr.replace(/零+$/, '');
    if (!chineseStr) {
        chineseStr = '零元';
    } else {
        chineseStr += '元';
    }

    // 处理小数部分
    if (decimalPart !== '00') {
        if (decimalPart[0] !== '0') {
            chineseStr += bigNumbers[parseInt(decimalPart[0])] + smallUnits[0];
        }
        if (decimalPart[1] !== '0') {
            chineseStr += bigNumbers[parseInt(decimalPart[1])] + smallUnits[1];
        }
    } else {
        chineseStr += '整';
    }
    return chineseStr;
}